import React, { useState } from "react";
import LeftImage from "../../assets/Images/signup.jpg";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import wlogo from "../../assets/Images/White_TCL_logo.png";
import "./login.css";

function LogIn() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.username || !formData.password) {
      setLoading(false);
      toast.error("Please fill in all fields");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const responseData = await response.json();
      if (response.ok) {
        if (responseData.status === "true") {
          sessionStorage.setItem("token", responseData.token);
          sessionStorage.setItem("isLoggedIn", true);
          toast.success("Login successful! Redirecting...");
          const redirectPath = sessionStorage.getItem("redirectAfterLogin") || "/";
          sessionStorage.removeItem("redirectAfterLogin"); // clean up
          setTimeout(() => navigate(redirectPath), 2000);

        } else {
          toast.error(responseData.message);
        }
      } else {
        toast.error("An error occurred while logging in.");
      }
    } catch (error) {
      toast.error("An error occurred while logging in.");
    } finally {
      setLoading(false);
      setFormData({ username: "", password: "" });
    }
  };

  const trigger = () => {
    navigate("/");
  };

  return (
    <div className="container-fluid" style={{ overflow: "hidden" }}>
      <ToastContainer />
      <div className="row justify-content-center m-0 position-relative">
        {loading && (
          <div className="spinner-overlay">
            <div className="spinner"></div>
          </div>
        )}

        {/* LEFT IMAGE PANEL */}
        <div className="col-lg-5 p-0 d-none d-lg-block">
          <div
            className="w-100 h-100"
            style={{
              backgroundImage: `url(${LeftImage})`,
              backgroundSize: "100% 100%",
            }}
          >
            <div
              className="ms-3"
              style={{ cursor: "pointer", color: "#FFFFFF" }}
              onClick={trigger}
            >
              <img
                className="d-none d-md-block"
                src={wlogo}
                width="185"
                alt="Logo"
              />
            </div>

            <div className="h-75 d-flex justify-content-center align-items-center">
              <p style={{ color: "#FFFFFF" }}>
                <b>LADAKH</b>
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="col-lg-7 col-12 position-relative p-0">
          {/* Blurred background image */}
          <div
            style={{
              backgroundImage: `url(${LeftImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "blur(10px)",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 0,
            }}
          />

          {/* Glassmorphic Card */}
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "100vh", position: "relative", zIndex: 1 }}
          >
            <div
              className="glassmorphic-card p-4"
              style={{
                backdropFilter: "blur(12px)",
                background: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "20px",
                width: "90%",
                maxWidth: "500px",
              }}
            >
              <div className="card-body px-2 px-md-5 py-1 py-md-4 w-100">
                <h1 className="card-title mt-2" style={{ color: "#03045E" }}>
                  LOGIN
                </h1>
                <p className="text-muted" style={{ fontSize: "medium" }}>
                  Hey, Enter your details to get login to your account
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="text"
                      name="username"
                      placeholder="Email ID"
                      value={formData.username}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                    <div className="text-end mt-2">
                      <Link
                        to="/forget-password"
                        className="link-dark"
                        style={{ textDecoration: "none" }}
                      >
                        Forget Password?
                      </Link>
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn"
                      style={{
                        borderRadius: "20px",
                        backgroundColor: "#03045E",
                        color: "white",
                        textDecoration: "none",
                      }}
                    >
                      Login
                    </button>
                  </div>
                  <p className="text-center mt-3">
                    Don't have an account?{" "}
                    <Link
                      to="/signup"
                      style={{
                        color: "#03045E",
                        fontWeight: "bold",
                        textDecoration: "none",
                      }}
                    >
                      Sign Up
                    </Link>
                    <span> now</span>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LogIn;
